import { observer } from 'mobx-react';
import { FC, useMemo } from 'react';
// eslint-disable-next-line max-len
import ModifierAndExclusionModalHeaderControls from '../../components/ModifierAndExclusionModalHeaderControls/ModifierAndExclusionModalHeaderControls';
import ModifierAndExclusionModalHeaderSearch from '../../components/ModifierAndExclusionModalHeaderSearch/ModifierAndExclusionModalHeaderSearch';
// eslint-disable-next-line max-len
import ModifierAndExclusionModalHeaderSections from '../../components/ModifierAndExclusionModalHeaderSections/ModifierAndExclusionModalHeaderSections';
import { mdfAndExclModalStore } from '../../store';
import { localeStore } from 'src/mobx/localesStore';
import { MODALS_CRUMB } from 'src/types/main';
import Crumbs from '~/view/components/Controls/Crumbs';

const ModifierAndExclusionModalHeader: FC = observer((): JSX.Element => {
  const { isMulti, isOnlyModifiers, isModifiersSection, selectedModifiers, selectedExclusions } = mdfAndExclModalStore;

  const selectedItemsNumber = useMemo((): number | null => {
    if (!isMulti) return null;

    return isModifiersSection ? selectedModifiers.length : selectedExclusions.length;
  }, [isMulti, isModifiersSection, selectedModifiers, selectedExclusions]);

  const crumbs = useMemo(() => {
    return [
      { label: localeStore.t('all'), value: MODALS_CRUMB.ALL },
      { label: localeStore.t('selected') + ` ${selectedItemsNumber ? selectedItemsNumber : ''}`, value: MODALS_CRUMB.SELECTED },
    ];
  }, [selectedItemsNumber]);

  if (isMulti) {
    return (
      <div className="d-flex flex-column justify-content-between px-8 pt-6 pb-3">
        <div className="d-flex flex-row align-items-center justify-content-between mb-4">
          {/* section row */}
          <ModifierAndExclusionModalHeaderSections />
          {/* search field */}
          <ModifierAndExclusionModalHeaderSearch />
        </div>
        {/* crumbs and controls row */}
        <div className="d-flex flex-row justify-content-between">
          {/* crumbs input */}
          <Crumbs crumbs={crumbs} activeCrumb={mdfAndExclModalStore.activeCrumb} onClick={mdfAndExclModalStore.changeCrumb} />
          {/* controls button */}
          <ModifierAndExclusionModalHeaderControls />
        </div>
      </div>
    );
  }

  return (
    <div className="d-flex flex-column justify-content-between px-8 pt-6 pb-3">
      {/* section row */}
      {isOnlyModifiers ? null : (
        <div className="mb-4">
          {/* section row */}
          <ModifierAndExclusionModalHeaderSections />
        </div>
      )}
      {/* crumbs and controls row */}
      <div className="d-flex flex-row justify-content-between">
        {/* crumbs or search input */}
        {isMulti ? (
          <Crumbs crumbs={crumbs} activeCrumb={mdfAndExclModalStore.activeCrumb} onClick={mdfAndExclModalStore.changeCrumb} />
        ) : (
          <ModifierAndExclusionModalHeaderSearch />
        )}

        {/* controls button */}
        <ModifierAndExclusionModalHeaderControls />
      </div>
    </div>
  );
});

export default ModifierAndExclusionModalHeader;
